// extracted by mini-css-extract-plugin
export default {"homeContainer":"styles_homeContainer__+NlTH","testButtons":"styles_testButtons__+nrmi","temp":"styles_temp__PRP0P","pageContainer":"styles_pageContainer__8ImFz"};